@if (!isMobile) {
  <div class="ngx-data-table__card">
    <div class="ngx-data-table"
      [ngClass]="{'ngx-data-table__disabled-click' : isLoading}">
      <data-table-header [rowIdProp]="rowIdProp"
        [isLoading]="isLoading"
        [columns]="columns"
        [currentSort]="currentSort"
        [rows]="rows"
        [showCheckboxes]="showCheckboxes"
        [selectedItems]="selectedItems"
        [allCustomerIds]="allCustomerIds"
        [canSelectAll]="canSelectAll"
        [disableIndividualRowAttribute]="disableIndividualRowAttribute"
        [disableCheckbox]="disableCheckbox"
        [useSmallRowSize]="useSmallRowSize"
        [isAllCustomersNonSpotlight]="checkAllCustomerNonSpotLight()"
        (onSortChange)="sortChange($event)"
        (onSelectAllOnPageOnly)="selectAllRowsOnPageOnly($event)"
        (onSelectAllCustomers)="onSelectAllCustomers($event)">
      </data-table-header>
      <data-table-body [rowIdProp]="rowIdProp"
        [rows]="rows"
        [columns]="columns"
        [isLoading]="isLoading"
        [isDetailView]="isDetailView"
        [actionableErrorText]="actionableErrorText"
        [showCheckboxes]="showCheckboxes"
        [noResultsMessage]="noResultsMessage"
        [isVisibleDeepLinkMsg]="isVisibleDeepLinkMsg"
        [deepLinkMessage]="deepLinkMessage"
        [detailProp]="detailProp"
        [detailColumns]="detailColumns"
        [disableIndividualRowAttribute]="disableIndividualRowAttribute"
        [disableCheckbox]="disableCheckbox"
        [disableDeleteIcon]="disableDeleteIcon"
        [disableSelect]="disableSelect"
        [isEnableSignatureMembership]="isEnableSignatureMembership"
        [hasOnClickListeners]="hasOnClickListeners"
        [isRowNotInteractable]="isRowNotInteractable"
        [useSmallRowSize]="useSmallRowSize"
        [detailViewNoteText]="detailViewNoteText"
        [rowId]="rowId"
        [openRowSubject$]="openRowSubject$"
        [noteProp]="noteProp"
        [infoCol]="infoCol"
        (onRowClick)="rowClicked($event)"
        (onCheckboxClick)="rowSelected($event)"
        (errorTextClick)="errorTextClicked()"
        (onButtonClick)="buttonClicked($event)"
        (onExternalLinkClick)="externalLinkClicked($event)"
        (onDeleteClick)="deleteClicked($event)"
        (deepLinkMessageClick)="onClickDeepLinkMsg()"
        (onOrderNumberClicked)="orderNumberClicked($event)">
      </data-table-body>
      @if (showFooter) {
        <data-table-footer
          [totalElements]="totalElements"
          [pageSizeOptions]="pageSizeOptions"
          [pageSize]="pageSize"
          [displayFooterNote]="displayFooterNote"
          [currentPage]="currentPage"
          [numberOfPages]="numberOfPages"
          [isMobile]="isMobile"
          (onPageSizeChange)="pageSizeChange($event)"
          (onPageChange)="pageChange($event)">
        </data-table-footer>
      }
    </div>
  </div>
} @else {
  @if (useFullMobileTable) {
    <mobile-data-table-full
      [totalElements]="totalElements"
      [rowIdProp]="rowIdProp"
      [isLoading]="isLoading"
      [isMobile]="isMobile"
      [columns]="columns"
      [rows]="rows"
      [currentSort]="currentSort"
      [isDetailView]="isDetailView"
      [noResultsMessage]="noResultsMessage"
      [detailProp]="detailProp"
      [detailColumns]="detailColumns"
      [useSmallRowSize]="useSmallRowSize"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      [numberOfPages]="numberOfPages"
      [detailViewNoteText]="detailViewNoteText"
      [rowId]="rowId"
      [isRowNotInteractable]="isRowNotInteractable"
      [openRowSubject$]="openRowSubject$"
      [disableIndividualRowAttribute]="disableIndividualRowAttribute"
      (onRowClick)="rowClicked($event)"
      (onSortChange)="sortChange($event)"
      (onPageChange)="pageChange($event)"
      (onOrderNumberClicked)="orderNumberClicked($event)">
    </mobile-data-table-full>
  }
  @if (!useFullMobileTable) {
    <mobile-data-table
      [currentPage]="currentPage"
      [columns]="columns"
      [totalElements]="totalElements"
      [rows]="rows"
      [useMembershipAsIcon]="useMembershipAsIcon"
      [rowIdProp]="rowIdProp"
      [allCustomerIds]="allCustomerIds"
      [selectedItems]="selectedItems"
      [noResultsMessage]="noResultsMessage"
      [isVisibleDeepLinkMsg]="isVisibleDeepLinkMsg"
      [deepLinkMessage]="deepLinkMessage"
      [numberOfPages]="numberOfPages"
      [pageSize]="infiniteScroll ? 30 : pageSize"
      [showFooter]="showFooter"
      [mobileDeleteEnabled]="mobileDeleteEnabled"
      [enableMobileCheckbox]="enableMobileCheckbox"
      [disableRipple]="disableRipple"
      [disableCheckboxes]="disableCheckbox"
      [disableIndividualRowAttribute]="disableIndividualRowAttribute"
      [disableSelect]="disableSelect"
      [isEnableSignatureMembership]="isEnableSignatureMembership"
      [shouldDisplayIcon]="shouldDisplayIcon"
      [shouldDisplayLabel]="shouldDisplayLabel"
      [shouldDisplayMemberText]="shouldDisplayMemberText"
      [hasOnClickListeners]="hasOnClickListeners"
      [isRowNotInteractable]="isRowNotInteractable"
      [loading]="isLoading"
      [mobileActionMenuMetaData]="mobileActionMenuMetaData"
      [noteProp]="noteProp"
      [infoCol]="infoCol"
      (onPageChange)="pageChange($event)"
      (onRowClick)="rowClicked($event)"
      (onCheckboxClick)="rowSelected($event)"
      (onDeleteClick)="deleteClicked($event)"
      (onSelectAllOnPageOnly)="selectAllRowsOnPageOnly($event)"
      (onSelectAllCustomers)="onSelectAllCustomers($event)"
      (deepLinkMessageClick)="onClickDeepLinkMsg()">
    </mobile-data-table>
  }
}
